<template>
    <div v-if="$store.state.user" :style="style">
        <v-auto-img v-if="$store.state.user.imagekey" :src="$store.state.user.imagekey" class="greeting-image" />
        <div class="greeting-text">{{$translate('Hello')}} {{name}}!</div>
    </div>
    <div v-else></div>
</template>

<script>
export default {
    name: 'zoezi-mygreeting',

    zoezi: {
        title: 'Greeting to customer',
        icon: 'mdi-human-greeting'
    },

    computed: {
        name() {
            if (!this.$store.state.user) {
                return null;
            }

            return this.$store.state.user.firstname || this.$store.state.user.lastname;
        },
        style() {
            return {'background-color': this.$root.siteconfig.appbar.props.backgroundColor, color: this.$root.siteconfig.appbar.props.color };
        }
    }
}
</script>
